



























































import { Component, Vue } from "vue-property-decorator";
import HomeFooter from "@/components/footer.vue";
import HomeHeader from "@/components/header.vue";
import WidgetGrid from "@/components/WidgetGrid.vue";
import { WidgetConfiguration } from "../interfaces/widgetConfiguration";
import { WidgetState } from "../interfaces/widgetState";
import { WidgetPayload } from "../interfaces/widgetPayload";
import { Layout } from "../interfaces/layout";

@Component({ components: { HomeFooter, HomeHeader, WidgetGrid } })
export default class Tools extends Vue {
    public items: Array<{
        config: WidgetConfiguration<WidgetState, WidgetPayload>[];
        layout: Layout[];
        description: string;
        title: string;
        class: string;
        onlyImage?: boolean;
        src?: string;
    }> = [
        {
            config: [],
            layout: [],
            title: "tools.studioManagerTitle",
            description: "tools.studioManagerDescription",
            class: "",
            onlyImage: true,
            src: "homepage/studioManager.gif",
        },
        {
            config: [],
            layout: [],
            title: "tools.accessrightsTitle",
            description: "tools.accessrightsDescription",
            class: "",
            onlyImage: true,
            src: "homepage/blockallow.gif",
        },
        {
            config: [],
            layout: [],
            title: "tools.plyrTitle",
            onlyImage: true,
            description: "tools.plyrDescription",
            class: "",
        },
        {
            config: [],
            layout: [],
            title: "tools.vcTitle",
            description: "tools.vcDescription",
            class: "",
            onlyImage: true,
            src: "homepage/vc.png",
        },
        {
            config: [
                {
                    widgetId: "Survey",
                    type: "radio",
                    state: {
                        questions: [
                            {
                                answer: "Yes",
                                checked: false,
                                id: "eJ2uTqdr9m4bhzfNs0JkL81lrx2oHDsE",
                            },
                            {
                                answer: "No",
                                checked: false,
                                id: "AhixCKC26Ft60T1QQ3GFdSgOEMt7xyg7",
                            },
                        ],
                        report: {
                            byPerson: {
                                test: ["Yes", "No"],
                            },
                            chart: {
                                No: 1,
                                Yes: 5,
                            },
                        },
                        showResults: true,
                        title: "Do you like this presentation?",
                    },
                },
            ],
            layout: [
                {
                    h: 12,
                    i: "Survey",
                    w: 12,
                    x: 0,
                    y: 0,
                },
            ],
            description: "tools.surveyDescription",
            title: "tools.surveyTitle",
            class: "widget large",
        },
        {
            config: [
                {
                    widgetId: "MD",
                    type: "markdown",
                    state: { text: "", title: "" },
                },
            ],
            layout: [
                {
                    h: 12,
                    i: "MD",
                    w: 12,
                    x: 0,
                    y: 0,
                },
            ],
            description: "tools.markdownDescription",
            title: "tools.markdownTitle",
            class: "widget large",
        },
        {
            config: [
                {
                    widgetId: "Upload-/Download Center",
                    type: "fileagent",
                    state: {
                        fileRecords: [
                            {
                                dimensions: {
                                    height: 0,
                                    width: 0,
                                },
                                ext: "csv",
                                lastModified: 1604486366738,
                                name: "data-export.csv",
                                size: 31,
                                sizeText: "31 B",
                                type: "text/csv",
                                upload: {
                                    data: {
                                        filename: "data-export.csv",
                                        id:
                                            "3861d061-eb6c-4daf-9643-86c58e7eeef4",
                                        widgetId:
                                            "3669730c-95eb-48ef-8d1f-bdbb097b7272",
                                    },
                                    error: false,
                                },
                                url: "/data-export.csv",
                                urlValue: "/data-export.csv",
                            },
                            {
                                dimensions: {
                                    height: 260,
                                    width: 300,
                                },
                                ext: "svg",
                                lastModified: 1604396558349,
                                name: "logo.svg",
                                size: 1631,
                                sizeText: "2 KB",
                                type: "image/svg+xml",
                                upload: {
                                    data: {
                                        filename: "logo.svg",
                                        id:
                                            "b00f24f3-6d3c-45f4-9119-ca9bc3b466ff",
                                        widgetId:
                                            "3669730c-95eb-48ef-8d1f-bdbb097b7272",
                                    },
                                    error: false,
                                },
                                url: "/logo.svg",
                                urlValue: "/logo.svg",
                            },
                        ],
                        title: "",
                        guestUpload: false,
                        themeToggle: true,
                    },
                },
            ],
            layout: [
                {
                    h: 6,
                    i: "Upload-/Download Center",
                    w: 12,
                    x: 0,
                    y: 0,
                },
            ],
            description: "tools.downloaderDescription",
            title: "tools.downloaderTitle",
            class: "widget normal",
        },

        {
            config: [
                {
                    widgetId: "Whiteboard",
                    type: "draw",
                    state: {},
                },
            ],
            layout: [
                {
                    h: 12,
                    i: "Whiteboard",
                    w: 12,
                    x: 0,
                    y: 0,
                },
            ],
            description: "tools.whiteBoardDescription",
            title: "tools.whiteBoardTitle",
            class: "widget large",
        },
        {
            config: [
                {
                    widgetId: "Chat",
                    type: "chat",
                    state: {
                        group: {
                            messages: [],
                        },
                        groupModeActive: true,
                        private: {
                            messages: [],
                            participants: [],
                        },
                        title: "",
                    },
                },
            ],
            layout: [
                {
                    h: 12,
                    i: "Chat",
                    w: 12,
                    x: 0,
                    y: 0,
                },
            ],
            description: "tools.chatDescription",
            title: "tools.chatTitle",
            class: "widget large",
        },
    ];
}
